import React from "react";

interface PauseIconProps {
  className?: string;
  title?: string;
  onClick?: () => void | Promise<void>;
}

export const PauseIcon: React.FC<PauseIconProps> = ({
  className = "",
  title = "",
  onClick,
}) => (
  <svg
    fill="currentColor"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    width="19px"
    height="19px"
    viewBox="0 0 478.125 478.125"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <title>{title}</title>
    <g>
      <g>
        <g>
          <path
            d="M201.654,127.525h-31.9c-10.557,0-19.125,8.645-19.125,19.125v184.9c0,10.558,8.645,19.125,19.125,19.125h31.9
				c10.557,0,19.125-8.645,19.125-19.125v-184.9C220.779,136.094,212.211,127.525,201.654,127.525z"
          />
          <path
            d="M308.448,127.525h-31.9c-10.558,0-19.125,8.645-19.125,19.125v184.9c0,10.558,8.645,19.125,19.125,19.125h31.9
				c10.557,0,19.125-8.645,19.125-19.125v-184.9C327.573,136.094,318.929,127.525,308.448,127.525z"
          />
          <path
            d="M239.062,0C107.023,0,0,107.023,0,239.062s107.023,239.062,239.062,239.062s239.062-107.023,239.062-239.062
				S371.102,0,239.062,0z M239.292,409.811c-94.171,0-170.519-76.424-170.519-170.519S145.197,68.773,239.292,68.773
				c94.095,0,170.519,76.424,170.519,170.519S333.54,409.811,239.292,409.811z"
          />
        </g>
      </g>
    </g>
  </svg>
);
